import $ from 'jquery';
import bodyScroll from '../scripts/bodyScroll';

$.addInit(function(context){
	var base = '.b-heroMenu';
	$(base, context).each(function(){
		var component = $(this);
		var btn = component.find(base + '-btn');
		var isActive = false;

		btn.on('click', function() {
			isActive = !isActive;
			component.toggleClass('m-active');

			if (isActive) {
				bodyScroll.disable(component.get(0), {reserveScrollBarGap: true});
			} else {
				bodyScroll.enable(component.get(0));
			}
		});
	});
});



//////////////////
// WEBPACK FOOTER
// ./src/components/b-heroMenu.js
// module id = 18
// module chunks = 0